import { Requester } from './Requester';
import { IContactRecord } from '../types';

export const GetOrganizationContacts = async ({
    orgId
}: {
    orgId: string;
}): Promise<{ contacts: IContactRecord[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ contacts: IContactRecord[]; totalRecords: number }>({
            // port: '8080',
            path: `organizations/${orgId}/contacts`,
            method: 'GET'
        });

        if ('contacts' in response && Array.isArray(response.contacts)) return response;
        return null;
    } catch (e) {
        console.error('Get org contacts request failed');
        return Promise.reject(e);
    }
};
